import type { AllocationOption } from '@/components/funding-sources-coordination/partner-allocation-section';

/**
 * Map a stored `splitRatio` back to the corresponding `AllocationOption`:
 *   - `null` → mirror (full each)
 *   - `50` → 50/50
 *   - any other value → custom
 */
export function deriveAllocationOption({
  isExistingMirror,
  existingSplitRatio,
}: {
  isExistingMirror: boolean;
  existingSplitRatio: number | null;
}): AllocationOption {
  if (!isExistingMirror) return 'mirror';
  if (existingSplitRatio == null) return 'mirror';
  if (existingSplitRatio === 50) return 'split-50-50';
  return 'custom';
}
